import { FC } from "react";
import { BasicProps } from "../../types/BasicProps";
import classNames from "classnames";

const InAuctionTag: FC<BasicProps> = ({ className }) => {
  return (
    <div
      className={classNames(
        "border-2 border-myred rounded-full text-sm px-3 py-2 flex justify-center items-center gap-1.5",
        className
      )}
    >
      <div className="w-[9px] h-[9px] rounded-full bg-myred"></div>
      <span>In Auction</span>
    </div>
  );
};

export default InAuctionTag;
